import { DateFormat, TimeFormat } from '../types';
import { TFunction } from 'i18next';
import { formats } from '../constants';
import { formatOrdinalNumber, formatDisplayName } from '../utils';
import { FormatDisplayNameOptions } from '@formatjs/intl';

export function localizeCurrency(value: string | number, t: TFunction): string {
  return t('formats.currency', {
    value,
    defaultValue: '{{ value, currency }}'
  });
}

export function localizeDate(value: any, t: TFunction, type: DateFormat = formats.dateShort): string {
  return t(`formats.${type}`, {
    value,
    defaultValue: `{{ value, ${type} }}`
  });
}

export function localizeDateTime(value: string | Date, t: TFunction): string {
  const { dateShort, timeMedium } = formats;

  const date = t(`formats.${dateShort}`, {
    value,
    defaultValue: `{{ value, ${dateShort} }}`
  });
  const time = t(`formats.${timeMedium}`, {
    value: {
      time: value
    },
    defaultValue: `{{ value, ${timeMedium} }}`
  });

  return `${date}, ${time}`;
}

export function localizeDistance(value: string | number, t: TFunction): string {
  return t('formats.distance', {
    value,
    defaultValue: '{{ value, distance }}'
  });
}

export function localizeNumber(value: any, t: TFunction): string {
  return t('formats.number', {
    value,
    defaultValue: '{{ value, number }}'
  });
}

export function localizeRelativeTime(
  value: string | number | Date,
  t: TFunction,
  type: string = formats.relativeLong
): string {
  return t(`formats.${type}`, {
    value,
    defaultValue: `{{ value, ${type} }}`
  });
}

export function localizeTime(value: any, t: TFunction, type: TimeFormat = formats.timeShort): string {
  return t(`formats.${type}`, {
    value,
    defaultValue: `{{ value, ${type} }}`
  });
}

export const stringFormat = (input: string, ...params: string[]): string =>
  input.replace(/{(\d+)}/g, (match, number) => params[number] ?? match);

export function localizeOrdinalNumber(value: string | number, t: TFunction) {
  return formatOrdinalNumber(value, t);
}

export function localizeDisplayName(value: string, options?: FormatDisplayNameOptions & { customLocale?: string }) {
  return formatDisplayName(value, options);
}
